import { Enum, EnumType } from 'ts-jenum';
import _ from 'lodash';
import { IconDefinition } from '@fortawesome/fontawesome-common-types';
import { faPhone as faPhoneRegular } from '@fortawesome/pro-regular-svg-icons';
import { faPhone as faPhoneSolid } from '@fortawesome/pro-solid-svg-icons';

@Enum<LineStatusType>('value')
export class LineStatusType extends EnumType<LineStatusType>() {
   public static readonly None = new LineStatusType('NONE', 0x0000, faPhoneRegular, 'state-none', 'samwin.contact-status.types.line_status_types.none', false);

   public static readonly Idle = new LineStatusType('IDLE', 0x0001, faPhoneSolid, 'state-idle', 'samwin.contact-status.types.line_status_types.idle', true);

   public static readonly Offering = new LineStatusType(
      'OFFERING',
      0x0002,
      faPhoneSolid,
      'state-offering',
      'samwin.contact-status.types.line_status_types.offering',
      true,
      'samwin.contact-status.types.line_status_types.with-connected-id.ringing'
   );

   public static readonly Accepted = new LineStatusType(
      'ACCEPTED',
      0x0004,
      faPhoneSolid,
      'state-accepted',
      'samwin.contact-status.types.line_status_types.accepted',
      true,
      'samwin.contact-status.types.line_status_types.with-connected-id.ringing'
   );

   public static readonly Dialtone = new LineStatusType(
      'DIALTONE',
      0x0008,
      faPhoneSolid,
      'state-dialtone',
      'samwin.contact-status.types.line_status_types.dialtone',
      true
   );

   public static readonly Dialing = new LineStatusType(
      'DIALING',
      0x0010,
      faPhoneSolid,
      'state-dialing',
      'samwin.contact-status.types.line_status_types.dialing',
      true,
      'samwin.contact-status.types.line_status_types.with-connected-id.calling'
   );

   public static readonly Ringback = new LineStatusType(
      'RINGBACK',
      0x0020,
      faPhoneSolid,
      'state-ringback',
      'samwin.contact-status.types.line_status_types.ringback',
      true,
      'samwin.contact-status.types.line_status_types.with-connected-id.calling'
   );

   public static readonly Busy = new LineStatusType('BUSY', 0x0040, faPhoneSolid, 'state-busy', 'samwin.contact-status.types.line_status_types.busy', true);

   public static readonly Connected = new LineStatusType(
      'CONNECTED',
      0x0100,
      faPhoneSolid,
      'state-connected',
      'samwin.contact-status.types.line_status_types.connected',
      true,
      'samwin.contact-status.types.line_status_types.with-connected-id.connected'
   );

   public static readonly Proceeding = new LineStatusType(
      'PROCEEDING',
      0x0200,
      faPhoneSolid,
      'state-proceeding',
      'samwin.contact-status.types.line_status_types.proceeding',
      true,
      'samwin.contact-status.types.line_status_types.with-connected-id.calling'
   );

   public static readonly OnHold = new LineStatusType(
      'ON_HOLD',
      0x0400,
      faPhoneSolid,
      'state-on-hold',
      'samwin.contact-status.types.line_status_types.on_hold',
      true,
      'samwin.contact-status.types.line_status_types.with-connected-id.on-hold'
   );

   public static readonly Conferenced = new LineStatusType(
      'CONFERENCED',
      0x0800,
      faPhoneSolid,
      'state-conferenced',
      'samwin.contact-status.types.line_status_types.conferenced',
      true
   );

   public static readonly OnHoldPendingConference = new LineStatusType(
      'ON_HOLD_PENDING_CONFERENCE',
      0x1000,
      faPhoneSolid,
      'state-on-hold-pending-conference',
      'samwin.contact-status.types.line_status_types.on_hold_pending_conference',
      true,
      'samwin.contact-status.types.line_status_types.with-connected-id.connected'
   );

   public static readonly OnHoldPendingTransfer = new LineStatusType(
      'ON_HOLD_PENDING_TRANSFER',
      0x2000,
      faPhoneSolid,
      'state-on-hold-pending-transfer',
      'samwin.contact-status.types.line_status_types.on_hold_pending_transfer',
      true,
      'samwin.contact-status.types.line_status_types.with-connected-id.connected'
   );

   public static readonly Disconnected = new LineStatusType(
      'DISCONNECTED',
      0x4000,
      faPhoneSolid,
      'state-disconnected',
      'samwin.contact-status.types.line_status_types.disconnected',
      true
   );

   public static readonly Unknown = new LineStatusType(
      'UNKNOWN',
      0x9999,
      faPhoneRegular,
      'state-unknown',
      'samwin.contact-status.types.line_status_types.unknown',
      false
   );

   private constructor(
      public value: string,
      public samwinValue: number,
      public statusIcon: IconDefinition,
      public styleClass: string,
      public translationKey: string,
      public displayTextDefault: boolean,
      public translationKeyWithConnectedId: string = translationKey
   ) {
      super();
   }

   public static getPresenceStatusBySamwinValue(samwinValue: number): LineStatusType {
      const allValues = LineStatusType.values();
      const value = _(allValues)
         .filter((x) => x.samwinValue === samwinValue)
         .head();
      return value ? value : LineStatusType.Unknown;
   }
}
